import Image from "next/image";
import { Minus, Plus } from "lucide-react";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Typography,
} from "@drpcrd/shared/ui";
import type { CampaignDeliveryStep } from "./campaign-delivery-items";

type Props = {
  step: CampaignDeliveryStep;
};

export const CampaignDeliveryAccordionItem = ({ step }: Props) => (
  <AccordionItem
    value={step.number}
    className="group border-b border-neutral-500 last:border-b-0"
  >
    <AccordionTrigger
      className="gap-2 py-2 hover:no-underline sm:py-3 [&[data-state=open]>svg]:rotate-0"
      icon={
        <div className="relative mt-0.5 flex size-3.5 shrink-0 items-center justify-center rounded-full border border-neutral-500 bg-white transition-colors group-hover:border-0 group-hover:bg-pink-500">
          <Plus
            size={12}
            className="absolute scale-100 text-black opacity-100 transition-all duration-200 group-hover:text-white group-data-[state=open]:scale-0 group-data-[state=open]:opacity-0"
            aria-hidden
          />
          <Minus
            size={12}
            className="absolute scale-0 text-black opacity-0 transition-all duration-200 group-hover:text-white group-data-[state=open]:scale-100 group-data-[state=open]:opacity-100"
            aria-hidden
          />
        </div>
      }
    >
      <span className="font-poppins shrink-0 text-2xl font-semibold tracking-[-0.04em] text-pink-500 sm:text-4xl">
        {step.number}
      </span>
      <Typography size="lg" weight="semibold" color="black" className="flex-1">
        {step.label}
      </Typography>
    </AccordionTrigger>
    <AccordionContent className="pb-3 sm:pb-2">
      <div className="flex h-50 w-full items-center justify-center overflow-hidden rounded-2xl bg-[linear-gradient(135deg,#BA9FFC_0.6%,#CC015D_100%)] pl-2 sm:h-70">
        <Image
          src={step.image}
          alt={step.label}
          className="h-full w-full max-w-70 object-contain"
        />
      </div>
    </AccordionContent>
  </AccordionItem>
);
